import axios from "axios";
import authHeader from "./auth-header";
import { config } from "../config";
import AuthService from "./auth.service";

class StockService {
  async getAll(params = {}) {
    const response = await axios.get(`${config.apiUrl}stocks`, {
      headers: authHeader(),
      params,
    });
    return response.data;
  }

  async getProducts() {
    return await axios.get(`${config.apiUrl}products`, {
      headers: authHeader(),
    });
  }

  async createProduct(data) {
    return await axios.post(`${config.apiUrl}products`, data, {
      headers: authHeader(),
    });
  }

  async getStorages() {
    return await axios.get(`${config.apiUrl}stocks/storages`, {
      headers: authHeader(),
    });
  }

  async create(data) {
    return await axios.post(`${config.apiUrl}stocks`, data, {
      headers: authHeader(),
    });
  }

  async update(id, data) {
    return await axios.put(`${config.apiUrl}stocks/${encodeURIComponent(id)}`, data, {
       headers: authHeader(),
    });
  }

  getWarehousesByReference(reference) {
    return axios
      .get(`${config.apiUrl}stocks/products/${encodeURIComponent(reference)}`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Erro ao buscar localizações de armazém:", err.response.data);
        return [];
      });
  }

  async getQueryProducts(params) {
    return await axios.get(`${config.apiUrl}products/query`, {
      headers: authHeader(),
      params: params,
    }).catch((err) => {
      if (err.response.status === 401) {
        AuthService.logout();
        window.location = "/login";
      }
      console.error("Erro ao buscar produtos:", err.response.data);
      return [];
    });
  }

  async getQueryWarehouses(params) {
    return await axios.get(`${config.apiUrl}stocks/warehouses/query`, {
      headers: authHeader(),
      params: params,
    }).catch((err) => {
      if (err.response.status === 401) {
        AuthService.logout();
        window.location = "/login";
      }
      console.error("Erro ao buscar produtos:", err.response.data);
      return [];
    });
  }

  async getListVats() {
    return await axios.get(`${config.apiUrl}stocks/vats`, {
      headers: authHeader(),
    }).catch((err) => {
      if (err.response.status === 401) {
        AuthService.logout();
        window.location = "/login";
      }
      console.error("Erro ao buscar IVA:", err.response.data);
      return [];
    });
  }
}

export default new StockService();
